import { render } from "./UpdateDeck.vue?vue&type=template&id=3e04c49c"
import script from "./UpdateDeck.vue?vue&type=script&lang=js"
export * from "./UpdateDeck.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__